import styled from 'styled-components';

export const EmptySlotContainer = styled.div`
  padding: 1.5em;
  border: 2px dashed rgba(33, 47, 79, 0.3);
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
`;

export const EmptySlotLabel = styled.div`
  text-align: center;
  font-size: 1.1em;
`;

export const EmptySlotActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1em;
`;
